/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyOBU,
    ReadOnlyOBUFromJSON,
    ReadOnlyOBUFromJSONTyped,
    ReadOnlyOBUToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20037
 */
export interface InlineResponse20037 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20037
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20037
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20037
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyOBU>}
     * @memberof InlineResponse20037
     */
    results: Array<ReadOnlyOBU>;
}

export function InlineResponse20037FromJSON(json: any): InlineResponse20037 {
    return InlineResponse20037FromJSONTyped(json, false);
}

export function InlineResponse20037FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20037 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyOBUFromJSON)),
    };
}

export function InlineResponse20037ToJSON(value?: InlineResponse20037 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyOBUToJSON)),
    };
}


